export interface IOrderSummaryLineItem {
  label: string;
  cost: number;
}
